import { TableColumn, TableUser, Tab } from './types';

export const ITEMS_PER_PAGE = 10;

export const USER_TABS: Tab[] = [
  { id: 'agency_directors', label: 'Agency Directors' },
  { id: 'agency_marketing_department', label: 'Agency Marketing department' },
];

export const TABLE_COLUMNS: TableColumn[] = [
  {
    id: 'name',
    label: 'Name',
    width: '20%',
    render: (row: TableUser) => `${row.firstName} ${row.lastName}`,
  },
  {
    id: 'agencies',
    label: 'Agencies',
    width: '25%',
    render: (row: TableUser) => {
      const agenciesText = renderAgencies(row.agencies);
      return <span title={agenciesText}>{agenciesText}</span>;
    },
  },
  {
    id: 'email',
    label: 'Email',
    width: '20%',
  },
  {
    id: 'phone',
    label: 'Phone',
    width: '15%',
  },
  {
    id: 'createdAt',
    label: 'Created',
    width: '15%',
    render: (row: TableUser) => {
      if (!row.createdAt) return '-';

      const date = new Date(row.createdAt);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    },
  },
];

export const renderAgencies = (agencies: { id: number; name: string }[]) => {
  return agencies.map((agency) => agency.name).join(', ');
};
